<template lang="html">
  <v-page :profile="profile" class="page-search">
    <v-topbar :profile="profile" />
    <v-breadcrumb
      :steps="[
        { label: 'Profissionais', to: { name: 'client-vibbrants' } },
        { label: 'Buscar' },
      ]"
    />

    <v-container v-if="this.canShowSearch == false">
      <SearchProfessional />
    </v-container>

    <v-container v-if="this.canShowSearch">
      <v-card class="p-3 mb-4">
        <v-filter-bar
          v-on:handleSearchClick="search"
          :profile="this.$route.query.profile"
          :focus="this.$route.query.focus"
        />
      </v-card>
      <v-row>
        <v-col :md="3">
          <v-button
            class="yellow block"
            :size="1"
            @click="showVibbranteXFreelaModal()"
            >Diferença de Vibbrante x Talent?</v-button
          >
        </v-col>
        <v-col :md="3" class="text-right">
          <v-button
            class="primary"
            :size="2"
            v-if="this.paginate.prev_page !== null"
            @click="prevPage()"
            >Anterior</v-button
          >
        </v-col>
        <v-col :md="3" class="text-center">
          Mostrando {{ this.paginate.current_page }} de
          {{ this.paginate.total_pages }} páginas
        </v-col>
        <v-col :md="3">
          <v-button
            class="primary"
            :size="2"
            v-if="this.paginate.next_page !== null"
            @click="nextPage()"
            >Próxima</v-button
          >
        </v-col>
      </v-row>
      <br />
      <v-row>
        <v-col :xs="12" :sm="12" :md="12" :lg="3">
          <v-card class="p-3 menu-selecteds">
            <v-text
              slot="title"
              tag="b"
              class="d-flex p-0 mb-3 align-items-center"
              ><span
                >Selecionados <small>{{ total_selecteds }}</small></span
              >
              <small class="ml-auto"
                ><v-link @click="clearAllSelected()">Limpar</v-link></small
              >
            </v-text>
            <v-content class="selected-users">
              <v-row :size="2">
                <v-col
                  :xs="6"
                  :sm="4"
                  :md="3"
                  :lg="12"
                  :xl="6"
                  v-for="vibbrante in selectedVibbrantes"
                  :key="vibbrante"
                >
                  <v-div class="p-2">
                    <v-avatar
                      class="pointer"
                      @click="openVibbranteNewTab(vibbrante)"
                      :image="vibbrante.avatar_old"
                      :name="vibbrante.name"
                      :about="vibbrante.profile"
                    >
                      <v-button-remove @click="removeVibbrante(vibbrante)" />
                    </v-avatar>
                  </v-div>
                </v-col>
              </v-row>
            </v-content>
            <v-button
              v-if="total_selecteds > 0"
              class="block primary mt-2"
              :to="{ name: 'client-search-request' }"
              :size="3"
              >Avançar</v-button
            >
            <br />
            <v-alert class="padding-info">
              <strong>DICA: </strong
              ><small
                >Clique em <b>Selecionar</b> e depois <b>Avançar</b> para
                convidar e esclarecer dúvidas com os profissionais</small
              >
            </v-alert>
          </v-card>
        </v-col>
        <v-col :xs="12" :sm="12" :md="12" :lg="9">
          <v-div class="user-items">
            <v-row class="size-2">
              <v-col
                :xs="12"
                :sm="12"
                :md="12"
                :lg="12"
                :xl="12"
                v-if="total_vibbrantes === 0"
              >
                <v-card class="mb-0 p-3">
                  <v-text tag="div"
                    >Nenhum profissional encontrado para esses filtros. Tente
                    outros :)</v-text
                  >
                </v-card>
              </v-col>
              <v-col
                :xs="12"
                :sm="6"
                :md="6"
                :lg="6"
                :xl="4"
                v-for="vibbrante in vibbrantes"
                v-if="vibbrante"
              >
                <v-card class="mb-0 p-3 card-user">
                  <v-avatar
                    class="pointer"
                    @click="openVibbranteNewTab(vibbrante)"
                    :view="list_view_type"
                    :name="vibbrante.name"
                    :about="vibbrante.profile + '<br>' + vibbrante.focus"
                    :image="vibbrante.avatar_old"
                  >
                  </v-avatar>
                  <v-list class="user-profile mt-3">
                    <v-text tag="div"
                      >Experiência:
                      <span>{{ vibbrante.years_experience }} anos</span></v-text
                    >
                    <v-text tag="div"
                      >Valor/hora:
                      <span>{{ vibbrante.hour_value | currency }}</span></v-text
                    >
                    <v-text tag="div"
                      >Horas semanais livres:
                      <span>{{ vibbrante.hour_available }}h</span></v-text
                    >
                  </v-list>
                  <v-div class="badges mt-2">
                    <v-badge
                      class=" badge-light"
                      v-for="sk in vibbrante.vibbrante_skills.slice(0, 5)"
                      >{{ sk.description }}</v-badge
                    >
                    <v-badge class=" badge-light">...</v-badge>
                  </v-div>
                  <v-button
                    class="block gray mt-3"
                    :size="2"
                    @click="selectVibbrante(vibbrante)"
                    >Selecionar</v-button
                  >
                  <v-stars
                    :stars="vibbrante.score"
                    slot="top-right"
                    v-if="vibbrante.vibbrante_type == 'vibbrante'"
                  ></v-stars>
                  <small
                    slot="top-left"
                    class="badge badge-success"
                    v-if="vibbrante.vibbrante_type == 'vibbrante'"
                    >{{ vibbrante.vibbrante_type }}!</small
                  >
                  <small
                    slot="top-left"
                    class="badge badge-light"
                    v-if="vibbrante.vibbrante_type == 'freelancer'"
                    >{{ vibbrante.vibbrante_type }}</small
                  >
                </v-card>
              </v-col>
            </v-row>
          </v-div>
        </v-col>
      </v-row>
      <br />
      <v-row>
        <v-col :md="3"></v-col>
        <v-col :md="3" class="text-right">
          <v-button
            class="primary"
            :size="2"
            v-if="this.paginate.prev_page !== null"
            @click="prevPage()"
            >Anterior</v-button
          >
        </v-col>
        <v-col :md="3" class="text-center">
          Mostrando {{ this.paginate.current_page }} de
          {{ this.paginate.total_pages }} páginas
        </v-col>
        <v-col :md="3">
          <v-button
            class="primary"
            :size="2"
            v-if="this.paginate.next_page !== null"
            @click="nextPage()"
            >Próxima</v-button
          >
        </v-col>
      </v-row>
    </v-container>

    <!-- MODALS -->
    <v-modals
      name="user"
      :show="user_modal_show"
      :data="{ user: selected_vibbrante }"
      @onHide="user_modal_show = false"
    />
    <v-modals
      name="vibbrante_x_freelancer"
      :show="vibbrante_x_freelancer_modal_show"
      :data="{}"
      @onHide="vibbrante_x_freelancer_modal_show = false"
    />
  </v-page>
</template>

<script>
import FilterBar from '../../../modules/filter-bar';
import ButtonRemove from '../../../modules/button-remove';
import clientApi from '@/api/client';
import SearchProfessional from '../../../components/search-form.vue';

export default {
  props: {
    profile: String,
  },
  components: {
    'v-filter-bar': FilterBar,
    'v-button-remove': ButtonRemove,
    SearchProfessional
  },
  created() {
    this.showSearch();

    if(this.canShowSearch){
      this.fetchData();
      const self = this;
      window.addEventListener('storage', e => {
        self.$store.dispatch('reloadSelectedVibbrantes');
      });
    }
  },
  mounted() {
    let top;
    let w;
    let filter_open = false;
    initVars();
    $(window).resize(event => {
      initVars();
    });
    $(window).scroll(function(event) {
      const y = $(this).scrollTop();
      if ($('.filter-bar').hasClass('filter-bar-more') && !filter_open) {
        initVars();
        filter_open = true;
      }
      if (!$('.filter-bar').hasClass('filter-bar-more') && filter_open) {
        initVars();
        filter_open = false;
      }
      if (y >= top) {
        $('.menu-selecteds').css('width', w);
        $('.menu-selecteds').addClass('fixed');
      } else {
        $('.menu-selecteds').css('width', 'auto');
        $('.menu-selecteds').removeClass('fixed');
      }
    });
    function initVars() {
      top =
        $('.menu-selecteds').offset().top -
        parseFloat(
          $('.menu-selecteds')
            .css('marginTop')
            .replace(/auto/, 100)
        ) -
        80;
      w = $('.menu-selecteds').outerWidth();
    }
  },
  data() {
    return {
      canShowSearch: false,
      list_view_type: 'card',
      user_modal_show: false,
      vibbrante_x_freelancer_modal_show: false,
      user_modal_id: 0,
      selected_vibbrante: {},
      options: {},
      filter: {
        filterBarGeneral: [],
        filterBarSkills: [],
        filterBarProfile: '',
        filterBarFocus: '',
        filterBarHourValue: [20, 1000],
        filterBarHoursWork: [0, 50],
        filterBarXP: [0, 50],
        filterBarType: '',
      },
      paginate: {
        current_page: 1,
        next_page: null,
        prev_page: null,
        total_pages: null,
        total_count: null,
      },
      lastFilter: {
        page: 1,
        filterBarGeneral: [],
        filterBarSkills: [],
        filterBarProfile: '',
        filterBarFocus: '',
        filterBarHourValue: [20, 1000],
        filterBarHoursWork: [0, 50],
        filterBarXP: [0, 50],
        filterVibbranteCode: null,
        filterBarType: '',
      },
    };
  },
  methods: {
    search(filter) {
      let preparedFilter = {};
      if (filter !== '') {
        preparedFilter = {
          page: filter.page,
          general: filter.filterBarGeneral,
          skills: filter.filterBarSkills,
          profile: filter.filterBarProfile,
          focus: filter.filterBarFocus,
          value_hour_min: filter.filterBarHourValue[0],
          value_hour_max: filter.filterBarHourValue[1],
          work_hour_min: filter.filterBarHoursWork[0],
          work_hour_max: filter.filterBarHoursWork[1],
          xp_min: filter.filterBarXP[0],
          xp_max: filter.filterBarXP[1],
          vibbrante_code: filter.filterVibbranteCode,
          vibbrante_type: filter.filterBarType,
        };
      }
      this.lastFilter = filter;
      clientApi
        .searchVibbrantes(preparedFilter)
        .then(response => {
          this.paginate = response.data.meta;
          this.$store.dispatch('search', response.data.vibbrantes);
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    showVibbranteXFreelaModal() {
      this.vibbrante_x_freelancer_modal_show = true;
    },
    openVibbranteNewTab(data) {
      const routeData = this.$router.resolve({
        // name: "client-search-vibbrante",
        path: '/client/search/vibbrante/' + data.slug,
      });
      window.open(routeData.href, '_blank');
    },
    selectVibbrante(data) {
      this.$store.dispatch('addSelVibbrante', data);
    },
    removeVibbrante(data) {
      this.user_modal_show = false;
      this.$store.dispatch('delSelVibbrante', data);
    },
    clearAllSelected() {
      this.$store.dispatch('delAllSelVibbrante');
    },
    prevPage() {
      this.lastFilter.page = this.paginate.prev_page;
      this.search(this.lastFilter);
    },
    nextPage() {
      this.lastFilter.page = this.paginate.next_page;
      this.search(this.lastFilter);
    },
    showSearch() {
      const email = this.$store.getters.user.email;
      const userId = this.$store.getters.user.id;
      this.canShowSearch = email.includes('@vibbra') || [3120, 1659, 4168, 3848].includes(userId);// 368
    },
    fetchData() {
      if (this.$route.query.profile === undefined) {
        this.search(this.lastFilter);
      } else {
        const filter = {};
        filter.page = 1;
        filter.filterBarProfile = this.$route.query.profile;
        filter.filterBarFocus = this.$route.query.focus;
        filter.filterBarGeneral = [];
        filter.filterBarSkills = [];
        filter.filterBarHourValue = [20, 1000];
        filter.filterBarHoursWork = [0, 50];
        filter.filterBarXP = [0, 50];
        filter.filterBarType = '';
        this.search(filter);
      }
    },
  },
  computed: {
    vibbrantes() {
      return this.$store.getters.vibbrantes;
    },
    total_vibbrantes() {
      return this.$store.getters.vibbrantes.length;
    },
    selectedVibbrantes() {
      return this.$store.getters.selected_vibbrantes;
    },
    total_selecteds() {
      return this.$store.getters.selected_vibbrantes.length;
    },
  },
};
</script>

<style lang="scss">
.page-search {
  @include media-breakpoint-up(lg) {
    .menu-selecteds {
      &.fixed {
        position: fixed;
        top: 80px;
      }
      .row {
        overflow: hidden;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
      }
    }
    .selected-users {
      max-height: calc(100vh - 430px);
      overflow-y: auto;
      overflow-x: hidden;
      @include scrollbar();
    }
  }
  .padding-info {
    padding: 1em;
  }
}
.avatar {
  position: relative;
}
.badges {
  margin: -0.2em;
  .badge {
    margin: 0.2em;
  }
}
.selected-users {
  .avatar {
    .avatar-name {
      font-size: 1em;
    }
    .avatar-about {
      font-size: 0.8em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/client/vibbrants/search.vue